import styled from '@emotion/styled';
import Image from 'next/image';
import { Center, Row } from '../../styles';
import { Grid } from '@mui/material';
import { shouldForwardProps } from '../../utils';

const ProjectContainer = styled(Grid, shouldForwardProps)`
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.spacing(3)};
    margin-left: ${({ theme }) => theme.spacing(3)};
    margin-right: ${({ theme }) => theme.spacing(3)};
    padding: ${({ theme }) => theme.spacing(3)};
`;

const EmptyContainer = styled(Center)`
    border-radius: 16px;
    height: auto;
    padding: ${({ theme }) => theme.spacing(3)};
`;

const EmptyBanner = styled(Image)`
    width: inherit;
    height: auto;
    border-radius: 12px;
`;

const EmptyBannerContent = styled(Center)`
    position: absolute;
    width: auto;
    height: auto;
`;

const FiltersRow = styled(Row, shouldForwardProps)`
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.spacing(2)};
    margin: ${({ theme }) => theme.spacing(3)};
`;

export { ProjectContainer, EmptyBanner, EmptyContainer, EmptyBannerContent, FiltersRow };
